import React from 'react'

import { SVG } from './UI'
import Icons from '../graphics/icons'

export default function Logo() {
    return (
        <SVG image={Icons.logo} primary contain/>
    )
}